"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.isTaprootRecipient = exports.validateRecipient = exports.calculateFees = void 0;
var errors_1 = require("@ledgerhq/errors");
var cache_1 = require("./../../cache");
var js_getFeesForTransaction_1 = __importDefault(require("./js-getFeesForTransaction"));
var logic_1 = require("./logic");
var wallet_btc_1 = require("./wallet-btc");
var getCacheKeyForCalculateFees = function (_a) {
    var a = _a.a, t = _a.t;
    return "".concat(a.id, "_").concat(a.blockHeight || 0, "_").concat(t.amount.toString(), "_").concat(String(t.useAllAmount), "_").concat(t.recipient, "_").concat(t.feePerByte ? t.feePerByte.toString() : "", "_").concat(0, "_").concat(t.utxoStrategy.strategy, "_").concat(String(t.rbf), "_").concat(t.utxoStrategy.excludeUTXOs
        .map(function (_a) {
        var hash = _a.hash, outputIndex = _a.outputIndex;
        return "".concat(hash, "@").concat(outputIndex);
    })
        .join("+"));
};
exports.calculateFees = (0, cache_1.makeLRUCache)(function (_a) {
    var account = _a.account, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, (0, js_getFeesForTransaction_1["default"])({
                    account: account,
                    transaction: transaction
                })];
        });
    });
}, function (_a) {
    var account = _a.account, transaction = _a.transaction;
    return getCacheKeyForCalculateFees({
        a: account,
        t: transaction
    });
}, {
    ttl: 5 * 60 * 1000
});
exports.validateRecipient = (0, cache_1.makeLRUCache)(function (currency, recipient) { return __awaiter(void 0, void 0, void 0, function () {
    var recipientWarning, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!recipient) {
                    return [2 /*return*/, {
                            recipientError: new errors_1.RecipientRequired(""),
                            recipientWarning: null
                        }];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, logic_1.isValidRecipient)({
                        currency: currency,
                        recipient: recipient
                    })];
            case 2:
                recipientWarning = _a.sent();
                return [2 /*return*/, {
                        recipientError: null,
                        recipientWarning: recipientWarning
                    }];
            case 3:
                e_1 = _a.sent();
                return [2 /*return*/, {
                        recipientError: e_1 instanceof Error ? e_1 : null,
                        recipientWarning: null
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); }, function (currency, recipient) { return "".concat(currency.id, "_").concat(recipient || ""); });
exports.isTaprootRecipient = (0, cache_1.makeLRUCache)(function (currency, recipient) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, wallet_btc_1.isTaprootAddress)(recipient, currency.id)];
    });
}); }, function (currency, recipient) { return "".concat(currency.id, "_").concat(recipient || ""); });
//# sourceMappingURL=cache.js.map